<ng-container *ngIf="[hint$ | async] as data">
  <p500-ui-number-field
    [label]="label"
    [formControl]="control"
    [className]="className"
    [hint]="data[0]?.hint"
    [placeholder]="data[0]?.placeholder || 'Enter number...'"
  >
  </p500-ui-number-field>
</ng-container>
